<template>
  <span class="igt-icon" :class="[{'background': background}, {'img': mode === 'img'}, 'color-'.concat(colorName), {'count': count > 0}]">
    <img v-if="mode === 'img'" class="img" :src="name" alt="Icon">
    <span v-if="mode === 'css'" class="css" :class="className" :style="styleObject"></span>
    <badge v-if="count > 0" :class="[{'small' : moreThanHundredLiveEvents}]">{{count}}</badge>
  </span>
</template>

<script>
import Badge from '@/components/common/Badge'

export default {
  name: 'Icon',

  components: {
    Badge
  },

  data () {
    return {
    }
  },

  props: {
    mode: {
      type: String,
      default: 'css'
    },

    name: {
      type: String,
      default: ''
    },

    background: {
      type: Boolean,
      default: false
    },

    colorName: {
      type: String,
      default: 'white'
    },

    count: {
      type: Number,
      default: 0
    },

    isFromSiteNavigation: {
      type: Boolean
    }
  },

  computed: {
    className () {
      return this.isClass(this.name) ? this.name.toLowerCase() : ''
    },

    styleObject () {
      return this.isClass(this.name) ? {} : {backgroundImage: 'url("' + this.name + '")'}
    },

    moreThanHundredLiveEvents () {
      if (this.isFromSiteNavigation && this.count >= 100) {
        return true
      } else return false
    }
  },

  methods: {
    isClass (value) {
      return value.indexOf('icon-') === 0
    }
  },

  created () {

  }
}
</script>

<style scoped lang="stylus">
  @import "~@/css/config"

  .igt-icon
    display: inline-block
    line-height: 0
    vertical-align: middle

    > span
      display: inline-block
      background-position: center
      background-size: 100%
      width: 25px
      height: 25px

    &.background
      background-color: #0E1929;
      height: 28px;
      width: 28px;
      align-items: center
      display: inline-flex
      justify-content: center
      border-radius: 50%

      .active &,
      .router-link-active &
        background-color: #2396FC

    for name in icon-names
      &.color-dark .icon-{name}
        background-image: url(svg-path'/'name'.svg')
      .icon-{name}-2
        background-image: url(svg-path'/'name'.svg')
      .icon-market-collapse
        background-image: url(svg-path'/'market-collapse'.svg')
      .icon-market-expand
        background-image: url(svg-path'/'market-expand'.svg')

      &.color-white .icon-{name},
      .icon-{name}
        background-image: url(svg-path'/'name'-white.svg')

      &.color-blue .icon-{name}
        background-image: url(svg-path'/'name'-blue.svg')

    for name in white1-icon-names
      &.color-white1 .icon-{name}
        background-image: url(svg-path'/'name'-white1.svg')

    for name in translux4-icon-names
      &.color-translux4 .icon-{name}
        background-image: url(svg-path'/'name'-translux4.png')

  &.count
    .css, .img
      display: none
</style>



// WEBPACK FOOTER //
// src/components/common/Icon.vue